<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.studentRankLevelDeletedList.push"
  >
    <el-table-column label="ID" prop="id" width="70"/>
    <el-table-column label="等级名称" prop="level_name" width="120"/>
    <el-table-column label="上课次数区间" width="160">
      <template v-slot="{ row }">
        {{ row.min_hours }} ~ {{ row.max_hours === null ? '无上限' : row.max_hours }}
      </template>
    </el-table-column>
    <el-table-column label="等级图标" width="180">
      <template v-slot="{ row }">
        <img v-if="row.icon_url" class="level-icon" :src="row.icon_url" alt=""/>
        <span v-else class="info-color">--</span>
      </template>
    </el-table-column>
    <v-column-time value="删除时间" field="is_del" sortable=""/>
    <el-table-column label="操作" width="120">
      <template v-slot="{ row }">
        <v-list-button
          name="恢复"
          icon="restore"
          @click="handleRestore(row)"
          :is-loading="isRestoring[row.id]"
          message="确定要恢复此等级吗？"
          :is-last="true"
        />
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`student-rank-level-deleted-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>等级名称</span>
              <span>{{ v.level_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>删除时间</span>
              <span>{{ v.is_del | timeToYmdHi }}</span>
            </div>

            <div class="list-item-button">
              <v-list-button
                name="恢复"
                icon="restore"
                @click="handleRestore(v)"
                :is-loading="isRestoring[v.id]"
                message="确定要恢复此等级吗？"
                :is-last="true"
              />
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { getLegalQueryList } from '@/utils/formats';
import { index, restore } from '@/api/student-rank-level';

export default {
  name: RouteConfig.studentRankLevelDeletedList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,    isRestoring: {},
    count: 0,
    list: [],
    queryList: {
      is_del: 1,
      page: 1,
      size: 10,
    },
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load(route = this.$route) {
      this.isLoading = true;
      getLegalQueryList(this.queryList, route.query);
      const { isError, data } = await index(this.queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count || 0;
      this.list = data.list || [];
    },
    async handleRestore({ id, update_time }) {
      if (!id || !Number.isInteger(update_time)) {
        return this.$message.warning('缺少等级信息，无法恢复！');
      }

      this.isRestoring = { ...this.isRestoring, [id]: true };
      const { isError } = await restore(id, { update_time });
      this.isRestoring = { ...this.isRestoring, [id]: false };
      if (isError) return;

      this.$message.success('恢复成功');
      this.load();
    },
  },
};
</script>

<style scoped>
.level-icon {
  display: block;
  width: 100px;
  height: 40px;
  object-fit: contain;
}
</style>
